export default {
  // Thu
  Income: 1,
  // Chi
  Spend: 2,
  // Cả thu và chi đều có
  Both: 0,
};
